var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12H12.3562L8.5875 1.16875C8.51886 0.973241 8.39119 0.803882 8.22212 0.684082C8.05306 0.564281 7.85096 0.499957 7.64375 0.5H6.35625C6.14904 0.499957 5.94694 0.564281 5.77788 0.684082C5.60881 0.803882 5.48114 0.973241 5.4125 1.16875L1.64375 12H0.5C0.367392 12 0.240215 12.0527 0.146447 12.1464C0.0526784 12.2402 0 12.3674 0 12.5C0 12.6326 0.0526784 12.7598 0.146447 12.8536C0.240215 12.9473 0.367392 13 0.5 13H13.5C13.6326 13 13.7598 12.9473 13.8536 12.8536C13.9473 12.7598 14 12.6326 14 12.5C14 12.3674 13.9473 12.2402 13.8536 12.1464C13.7598 12.0527 13.6326 12 13.5 12ZM4.9625 5.5H9.0375L10.0813 8.5H3.91875L4.9625 5.5Z",
    fill: "#1C86F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCone);
export default __webpack_public_path__ + "static/media/blue_cone.493bc62663db60ff7b877ddc3526352b.svg";
export { ForwardRef as ReactComponent };